// extracted by mini-css-extract-plugin
export default {"leftPaneContainer":"styles_leftPaneContainer__2qnTw","rightPaneContainer":"styles_rightPaneContainer__bHqN4","contentTitle":"styles_contentTitle__SmRcy"};